import React from 'react';
import { i18n } from 'core/i18n';
import { getTooltipOptions, getCardTypeHire } from 'utilities/cardsHelper';
const { FormattedText } = i18n;
import OKTooltip from 'commonsComponents/OKTooltip';

const HireNewToolTip = ({ state, immGlobalVariables, revolvingPackId, creditType, setTooltipShown }) => {

    const getMonthlyValues = () => ({
        'open-credit': immGlobalVariables.getIn(['variables', 'parameters', 'open_credit', 'aplazado_mensual']),
        'diamond': immGlobalVariables.getIn(['variables', 'parameters', 'pack_diamond', 'aplazado_mensual']),
        'premium': immGlobalVariables.getIn(['variables', 'parameters', 'pack_premium', 'aplazado_mensual']),
        'revolving': immGlobalVariables.getIn(['variables', 'parameters', `revolving_pack_${revolvingPackId}`, 'aplazado_mensual']),
        'viat': immGlobalVariables.getIn(['variables', 'parameters', 'via-t', 'aplazado_mensual']),
    });

    const buildExtraText = () => (
        <div>
            <div className="hire-payment-method__tooltip-title">
                <FormattedText value={getTooltipOptions("cardChangeAndHirePaymentMethod-tooltipOptionsThirdLabel", getCardTypeHire(creditType))} />
            </div>
            <div className="hire-payment-method__tooltip-text">
                <FormattedText value={getTooltipOptions("cardChangeAndHirePaymentMethod-tooltipOptionsThirdText", getCardTypeHire(creditType))} />
            </div>
        </div>
    );

    const buildMainLabelTooltip = () => {
        const monthlyValues = getMonthlyValues();
        const { tin, tae } = state;
        const monthly = monthlyValues[creditType];
        const extraText = buildExtraText();

        return (
            <article className="hire-payment-method__tooltip">
                <div className="hire-payment-method__tooltip-title">
                    <FormattedText value={'hireNewCreditCard-tooltip_infoTitle'} />
                </div>
                <div className="hire-payment-method__tooltip-text">
                    <FormattedText value={'hireNewCreditCard-tooltip_info'} />
                </div>
            </article>
        );
    };


    return (
        <OKTooltip
            content={buildMainLabelTooltip()}
            offset={[0, -10]}
            onHover={() => setTooltipShown('tooltipInfoShown')}
            type="custom"
        />
    );
};


export default HireNewToolTip;